import React, { Component } from 'react';
import { UncontrolledTooltip, Tooltip, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import device from '../../utilitarios/device';
import { EliminarDispositivo, getData } from '../../store/sagas/perfilApi';
import Platform from 'react-platform-js'
import { getDevice } from '../../store/sagas/utilApi';
import Spinner from "../reusable/Loader";

export class Dispositivos extends Component {
  static displayName = Dispositivos.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      modalEdit: false,
      loading: true,
      dispositivos: [],
      dispositivoActual: device.prototype.getMacCookie(),
      showTooltip: null
    };
  }

  toggleTooltip = (index) => {
    // this.setState(prevState => ({
    //   showTooltip: !prevState.showTooltip
    // }));
    this.setState({ showTooltip: index === this.state.showTooltip ? null : index })
  }

  checkParams() {
    const DispositivoId = getDevice();
    const { state } = this.props.location;
    this.setState({
      dispositivos: state.dispositivos == null ? [] : state.dispositivos, 
      dealer: state.dealer,
      asociado: state.asociado,
      linea: state.linea,
      loading: false,
      MI_DISPOSITIVO: DispositivoId
    })
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { dispositivoActual, dispositivos, loading, showTooltip } = this.state;
    const navigation = this.props.navigation
    const auth = this.context;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="rs_container desktop">
          <button className='btn-icon back mobile'
          >
            <SvgAssets icon="icon-arrow-left" fill={c.azulClaro} />
          </button>
          <SvgAssets className="icon" icon="icon-user" fill={c.rojoClaro} />
          <h6 className="title-2">{auth.userRazonSocial}</h6>
          <p className="paragraph-1 azul">Repuestos</p>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/perfil'>Mi Perfil</Link></li>
              <li><Link to='/dispositivos' style={{ pointerEvents: 'none' }}>Dispositivos</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="pt-4 pb-2 mobile">
          <Button color="link" className="btn-back"   onClick={() => this.props.history.goBack()}>
            <SvgAssets icon="icon-arrow-left" fill="#fff" />
            </Button>
          <h6 className="title-2 white text-center mb-0">{auth.userRazonSocial}</h6>
        </Container>
        <hr className="mobile" style={{ borderColor: c.celeste }} />
        <Container className="pt-2 pb-5">
          <h6 className="title white mobile"><SvgAssets icon="icon-phone" fill={'#fff'} />Tus Dispositivos</h6>
          <div className="card container_1080 content_dispositivos">
            <SvgAssets icon="curve-top" className='curve-out' fill="#fff" />
            <h6 className="title desktop_parrafo1 desktop"><SvgAssets icon="icon-phone" fill={c.azulClaro} />Tus Dispositivos</h6>
            <p className="paragraph-2 light" style={{ color: c.azulClaro }}>Accediste a tu cuenta de Crosland en estos dispositivos</p>
            <div className="content_cards">
            {dispositivos.map((data, index) => {
              return (
                <div className="card_product_horizontal card_dispositivo" key={index}>
                  <div className="cphCounterInput">
                    <SvgAssets icon={data.codigo.length < 22 ? "icon-desktop" :"icon-phone"} fill={c.morado} />
                  </div>
                  <div className="cphTextCenter">
                    <h6 className="paragraph-2 bold mb-0" style={{ color: c.azulClaro }}>{data.descripcion}</h6>
                    <span className="paragraph-3 light mt-1" style={{ color: c.azulClaro }}>{data.codigo}</span>
                    {(data.fechaAccesoStr != "") ?
                      <span className="paragraph-3 light mt-3" style={{ color: c.grisMedio }}>Última sesión:</span>
                      : null}
                    {(data.fechaAccesoStr != "") ?
                      <span className="paragraph-3 light" style={{ color: c.grisMedio }}>{data.fechaAccesoStr}</span>
                      : null}
                    {(data.codigo == dispositivoActual) ?
                      <span className="paragraph-3 mt-3 " style={{ color: c.verdeClaro }}>
                        <SvgAssets icon="icon-check" fill={c.verde} className="check" />Este dispositivo</span>
                      : null}
                  </div>
                  <div className={`cphCounterInput p-0 ${(data.codigo == dispositivoActual) ? " disabled" : ""}`} 
                    id={`tooltip-eliminar${index}`} style={{ backgroundColor: c.morado }}>

                    <SvgAssets icon="icon-dots" fill="#fff" />
                    {/* <UncontrolledTooltip                     
                     trigger="legacy" placement="left" target={`tooltip-eliminar${index}`} className="tooltip-salir">
                      <div onClick={() => this.postEliminar(data.dispositivoId, data.codigo)}>
                        Salir
                      </div>
                    </UncontrolledTooltip> */}
                    <Tooltip 
                      trigger="legacy" 
                      placement="left" 
                      isOpen={showTooltip === index} target={`tooltip-eliminar${index}`} 
                      toggle={() => { this.toggleTooltip(index) }} 
                      className="tooltip-salir"
                    >
                      <div onClick={() => this.postEliminar(data.dispositivoId, data.codigo)}>
                        Salir
                      </div>
                    </Tooltip>
                  </div>
                </div>
              )
            })}
            </div>
            <div className="text-center mt-3 mobile">
              <Link to="/perfil" style={{ textDecoration: 'none' }}>
                <button className='btn-block btn-regresar'><SvgAssets icon="icon-arrow-left" fill="#fff" />REGRESAR</button>
              </Link>
            </div>
          </div>
          <div className="text-center mt-5 desktop">
              <Link to="/perfil" style={{ textDecoration: 'none' }}>
                <button className='btn-block btn-regresar'><SvgAssets icon="icon-arrow-left" fill="#fff" />REGRESAR</button>
              </Link>
            </div>
        </Container>
      </div>
    );
  }

  postEliminar = async (Id, Codigo) => {
    // this.setState({ loading: true })
    this.setState({showTooltip: null});
    EliminarDispositivo(Codigo, this.state.dealer.codcliente, this.state.dealer.correoElectronico, Id,
      this.state.linea.vkorg, this.state.asociado.poblacion, this.state.linea.canal,
      this.state.linea.sector)
      .then(result => {
        if (result.mo.type == "success") {
          console.log("result.dto==>", result.dto);
          this.setState({
            loading: false,
            dispositivos: result.dto.perfil.dispositivos
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Perfil", error.message ?? null);
        });
      });

  }
}
